import React from 'react';
import PropTypes from 'prop-types';
import { PencilIcon } from '../../../atoms/icons/EditorialProfileIcons';
import './index.scss';

export default function HomeCtaSection({
  title,
  subtitle,
  primaryLabel,
  primaryAction,
  secondaryLabel,
  secondaryAction,
}) {
  return (
    <section className="home-cta">
      <div className="home-cta__container">
        <h2 className="home-cta__title">{title}</h2>
        {subtitle ? <p className="home-cta__sub">{subtitle}</p> : null}
        <div className="home-cta__actions">
          {primaryLabel ? (
            <button type="button" className="home-cta__btn home-cta__btn--accent" onClick={primaryAction}>
              <PencilIcon width="16" height="16" />
              {primaryLabel}
            </button>
          ) : null}
          {secondaryLabel ? (
            <button type="button" className="home-cta__btn home-cta__btn--ghost" onClick={secondaryAction}>
              {secondaryLabel}
            </button>
          ) : null}
        </div>
      </div>
    </section>
  );
}

HomeCtaSection.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  primaryLabel: PropTypes.node,
  primaryAction: PropTypes.func,
  secondaryLabel: PropTypes.node,
  secondaryAction: PropTypes.func,
};
